import { Col, Space } from "components/primitives";
import { useState } from "react";
import { Form } from "react-bootstrap";
import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";

import { InfoState } from "./types";

export const FreeDrawingToolSettings: WidgetSettingFC<any, InfoState> = (props) => {
  const {
    data,
    setData,
    info: { label, graph },
    state,
  } = props;

  const [isChecked, setIsChecked] = useState(false);

  return (
    <OuterContainer noMargin={false}>
      {/* <p className="label">{props?.info?.label}</p> */}
      <Space />
      {/* <p className="label">{graph.switchLabel}</p>
      <InnerContainer>
        <Switch>
          <Form.Control
            checked={isChecked}
            type="checkbox"
            onChange={() => {
              setIsChecked(!isChecked);

              setData({
                ...data,
                disableDrag: !isChecked,
              });
            }}
          />
          <Slider />
        </Switch>
      </InnerContainer> */}
    </OuterContainer>
  );
};

const OuterContainer = styled(Col)<{ noMargin: boolean }>`
  margin-bottom: ${(props) => (props.noMargin ? "0px" : "35px")};

  .label {
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 12pt;
  }
`;

const Row = styled.div<{ center?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${(props) => (props.center ? `space-evenly` : "flex-start")};
  gap: 8px;
`;

const InnerContainer = styled(Row)`
  align-items: center;
  gap: 10px;

  span {
    color: var(--gray);
  }
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 26px;

  :before {
    position: absolute;
    content: "";
    height: 80%;
    aspect-ratio: 1;
    left: 0;
    top: 50%;
    transform: translate(15%, -50%);
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }
`;

const Switch = styled(Form.Label)`
  position: relative;
  display: inline-block;
  height: 30px;
  margin: 0;
  aspect-ratio: 2;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  input:checked + ${Slider} {
    background-color: var(--primary);
  }

  input:checked + ${Slider}:before {
    left: 100%;
    transform: translate(-115%, -50%);
  }
`;

export default FreeDrawingToolSettings;
